/**
 * Drone Awareness — unified layer group combining:
 *   - Prisons & military zones (hazards.ts)
 *   - National parks / protected areas (drone-awareness-parks.ts)
 *
 * Note: Runway fan zones + boundary circles are now part of the
 * "Airports" toggle (airports.ts) rather than this group.
 */
import type mapboxgl from 'mapbox-gl';
import { addHazardLayers, removeHazardLayers } from './hazards';
import { addDroneAwarenessParksLayer, removeDroneAwarenessParksLayer } from './drone-awareness-parks';

export async function addDroneAwarenessLayers(map: mapboxgl.Map): Promise<void> {
  await Promise.all([
    addHazardLayers(map),
    addDroneAwarenessParksLayer(map),
  ]);
}

export function removeDroneAwarenessLayers(map: mapboxgl.Map): void {
  removeHazardLayers(map);
  removeDroneAwarenessParksLayer(map);
}
